import { configApiRef, identityApiRef, useApi } from '@backstage/core-plugin-api';
import { handleReponse } from '../helper';

type AuthedFetchInit = Omit<RequestInit, 'headers'> & {
  json?: unknown;
};

/**
 * Returns a fetch wrapper that targets `${backendUrl}/api/bidone<path>` and
 * attaches a Backstage bearer token. Pass `json` instead of `body` to have the
 * payload serialised and the content-type set automatically.
 */
export const useAuthedFetch = () => {
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const backendUrl = config.getString('backend.baseUrl');

  return async (path: string, init: AuthedFetchInit = {}) => {
    const { token } = await identityApi.getCredentials();
    const { json, body, ...rest } = init;
    const response = await fetch(`${backendUrl}/api/bidone${path}`, {
      ...rest,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: json !== undefined ? JSON.stringify(json) : body,
    });
    return handleReponse(response);
  };
};
